export default __webpack_public_path__ + "static/media/trade-page.90dc5302.png";